import { useEffect, useRef } from 'react';

// https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
export default function usePrevious<T>(val: T) {
  const ref = useRef(val);
  useEffect(() => {
    ref.current = val;
  });
  return ref.current;
}
